import { AssetLibraryAppNameODataHeader } from '@bingads-webui-campaign-react/asset-library-model';

//
export const getODataConfig = ({ token, campaignAPIServiceEndPoint }) => {
  const isLocal = () => {
    const hostname = document.location.hostname.toLowerCase();
    return hostname.indexOf('ads.microsoft.com') === -1 &&
        hostname.indexOf('ads-int.microsoft.com') === -1;
  };

  const odataPath = isLocal() ? 'Advertiser/V2' : 'Campaign/V2';

  const oDataConfig = {
    odataToken: token,
    oDataToken: token,
    odataPath: `${campaignAPIServiceEndPoint}${odataPath}`,
    oDataPath: `${campaignAPIServiceEndPoint}${odataPath}`,
    applicationName: AssetLibraryAppNameODataHeader.value,
    beforeSend: xhr => ({
      onBeforeSendDone: () => {
        xhr.setRequestHeader(AssetLibraryAppNameODataHeader.key, AssetLibraryAppNameODataHeader.value);
      },
    }),
  };
  return oDataConfig;
};
